import axios from 'axios';
import * as urlUtils from 'utils/Url';


export async function loadSeverSideData(config, pageStore) {
  try {
    const res = await axios(config);
    const data = await res.data;
    pageStore.deserialize(data);
    pageStore.setIsLoading(false);
  } catch (error) {
    let errors = error.response.data.errors;
    if (!errors) errors = error.response.data;
    if (!Array.isArray(errors)) errors = [errors.toString()];
    pageStore.setErrors(errors);
    pageStore.setIsLoading(false);
  }
}

export function getTitanPageUrl(path, qs={}) {
  return urlUtils.appendQueryString(`${process.env.TITAN_API_SERVER}/${path}`, qs);
}

